import client from '../client/client'

interface ChangeMediaPrivacyParams{
mediaId:number,
privacy:number
}

const getReports = async (params: any) => {
  try {
    return await client.get(`/api/v1/admin/reported-media`, {
      params: params,
    })
  } catch (error) {
    return error
  }
}

const mediaPrivacyRequest = async ({ mediaId, privacy }: ChangeMediaPrivacyParams) =>{
  try
  {
    return await client.post(`/api/v1/admin/media-privacy`,{
      mediaId,
      privacy
    })
  }catch(error){
    return error
  }
}

// const deleteExplore = async (Id: any) => {
//   try {
//     return await client.delete(`api/v1/admin/media/delete/${Id}`)
//   } catch (error) {
//     return error
//   }
// }
export {getReports,mediaPrivacyRequest}
